import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  /** @type {number | undefined} */
  #addedTimer;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  /** @param {Event} event */
  #handleCartAdd = (event) => {
    // K9: confirm the add inside the drawer (CartAddEvent shares its event name with quantity updates)
    if (event instanceof CartAddEvent) {
      const status = this.querySelector('[data-cart-added-status]');
      const failed = !!event.detail?.data?.didError;
      if (status instanceof HTMLElement) {
        status.textContent = failed ? '' : status.dataset.message || '';
        // K9: the confirmation clears itself after 3s (already announced by then)
        clearTimeout(this.#addedTimer);
        this.#addedTimer = setTimeout(() => (status.textContent = ''), 3000);
      }
      // K9: a failed add keeps the drawer shut so the product form's error stays visible and announced
      if (failed) return;
    }

    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    // K9: opened from the cart icon, not after an add, so no "added" confirmation
    const status = this.querySelector('[data-cart-added-status]');
    if (status instanceof HTMLElement) status.textContent = '';

    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
